type EngineDownloadSource = {
  downloadLabel?: string | null;
  downloadPath?: string | null;
  downloadFallbackPath?: string | null;
  downloadArtifactStatus?: string | null;
};

export type EngineDownloadDisplay = {
  label: string;
  detail: string;
  action: string;
  path: string | null;
  platformNote: string;
  externalDownload: boolean;
};

export function describeEngineDownload(engine: EngineDownloadSource | null | undefined): EngineDownloadDisplay {
  const path = engine?.downloadPath || engine?.downloadFallbackPath || null;
  const isMac = path?.includes('/macos/') ?? true;

  return {
    label: 'Download Oracord Engine',
    detail: isMac
      ? 'Download the Mac installer first, then create the setup link and pair it to this company.'
      : 'Download Oracord Engine first, then create the setup link and pair it to this company.',
    action: isMac ? 'Download for Mac' : 'Download installer',
    path,
    platformNote: isMac ? 'Mac installer available. Windows installer is not available yet.' : 'Installer available.',
    externalDownload: Boolean(path),
  };
}
